import { createTheme } from '@material-ui/core/styles';
// import { lighten } from 'material-ui/styles/colorManipulator';

import { COLORS } from '../../styles/constants';
import { theme, cn_theme } from '../../styles/theme';
import { getDomain } from '../../utils/config';

const defaultMuiTheme = createTheme();
const mainTheme = getDomain() === 'onsemi.com' ? theme : cn_theme;

const tableTheme = createTheme({
	...mainTheme,
	overrides: {
		MuiPaper: {
			rounded: {
				border: `1px solid ${COLORS.BORDER}`,
				borderTopLeftRadius: '4px',
				borderTopRightRadius: '4px'
			}
		},
		MuiPopover: {
			paper: {
				border: 0,
				borderTop: `1px solid ${COLORS.WHITE}`
			}
		},
		MuiSwitch: {
			thumb: {
				boxShadow: defaultMuiTheme.shadows[1]
			}
		},
		MuiInput: {
			input: {
				'&::placeholder': {
					fontSize: mainTheme.typography.body2.fontSize
				}
			}
		},
		MuiIconButton: {
			colorInherit: {
				color: mainTheme.palette.text.secondary
			}
		},
		MuiTableRow: {
			root: {
				height: 56
			}
		},
		MuiTableCell: {
			root: {
				[mainTheme.breakpoints.up('md')]: {
					'&:first-child': {
						paddingLeft: mainTheme.spacing(2)
					},
					'&:last-child': {
						paddingRight: mainTheme.spacing(2)
					}
				},
				[mainTheme.breakpoints.down('sm')]: {
					paddingLeft: mainTheme.spacing(2)
				},
				minWidth: 66,
				padding: mainTheme.spacing(1),
				fontSize: mainTheme.typography.body2.fontSize,
				wordBreak: 'keep-all',
				borderBottom: `1px solid ${COLORS.BORDER_TABLE_ROW}`
			}
		},
		MuiTooltip: {
			tooltip: {
				fontSize: mainTheme.typography.body2.fontSize
			}
		},
		MUIDataTableToolbar: {
			root: {
				padding: `0 ${mainTheme.spacing(1)}px`,
				marginTop: 0
			},
			actions: {
				padding: `${mainTheme.spacing(1)}px 0`
			},
			icon: {
				'&:hover': {
					color: 'default'
				}
			}
		},
		MUIDataTableSearch: {
			clearIcon: {
				'&:hover': {
					color: 'default'
				}
			},
			searchIcon: {
				marginTop: 12,
				marginRight: 6
			},
			searchText: {
				marginTop: 8
			}
		},
		MUIDataTableHeadCell: {
			root: {
				paddingTop: 0
			},
			toolButton: {
				padding: '1px 4px',
				'&:hover': {
					color: mainTheme.palette.text.secondary,
					backgroundColor: 'inherit'
				},
				fontSize: mainTheme.typography.body2.fontSize
			}
		},
		MUIDataTableBodyCell: {
			stackedCommon: {
				fontSize: `${mainTheme.typography.body2.fontSize} !important`
			}
		},
		MuiTableHead: {
			root: {
				position: 'relative',
				backgroundColor: 'white',
				zIndex: '1000 !important'
			}
		}
	}
});

export default tableTheme;
